import isEmpty from 'lodash/isEmpty';
import { fetchNetSalesSummary } from 'dashboard/actions/net-sales/net-sales-summary.actions';
import { downloadNetSalesHistoryReport, fetchNetSalesDetails } from 'dashboard/actions/net-sales/net-sales-details.actions';
import { setActiveTab } from 'utils/actions/active-tab/active-tab.actions';
import tabs from '../../tabs';

const mapStateToThis = ({ session, netSales, ui, dictionary }) => {
  const { locale } = session;
  const { activeTab } = ui;
  const { netSalesSummary, instantGames, drawGames } = netSales;
  const { WTD, MTD, QTD, YTD } = tabs;
  const terms = dictionary.terms[locale];

  return {
    activeTab,
    drawGames,
    instantGames,
    netSalesSummary,
    activeSummaryPeriod: netSalesSummary[activeTab],
    activeInstantGamesPeriod: instantGames[activeTab],
    activeDrawGamesPeriod: drawGames[activeTab],
    WTD,
    MTD,
    QTD,
    YTD,
    terms,
  };
};

const mapDispatchToThis = {
  fetchNetSalesSummary,
  fetchNetSalesDetails,
  setActiveTab,
  downloadNetSalesHistoryReport,
};

@Inject('$ngRedux', 'gettextCatalog', '$state')
export class NetSalesHistoryPageController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
    this.tabs = tabs;
    this.retailerId = this.$state.params.retailerNo;
    /// {{ draw }} is Lottery term using to determine Draw games.
    this.drawGamesHeader = this.gettextCatalog.getString('{{ draw }} Games', { draw: this.terms.DRAW.singular });
    /// {{ instant }} is Lottery term using to determine Instant games.
    this.instantGamesHeader = this.gettextCatalog.getString('{{ instant }} Games', { instant: this.terms.INSTANT.singular });
  }

  async $onInit() {
    await Promise.all([this.fetchNetSalesDetails(this.retailerId), this.fetchNetSalesSummary()]);
    this.setActiveTab(this.WTD, 'activeTab');
  }

  $onDestroy() {
    this.setActiveTab('', 'activeTab');
    this.unsubscribe();
  }

  downloadReport(extension) {
    const config = {
      id: this.retailerId,
      periodType: this.activeTab,
      extension,
    };
    return this.downloadNetSalesHistoryReport(config);
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/net-sales/components/net-sales-history-page/net-sales-history-page-controller.js